import React, { useEffect, useContext } from "react";
import styled from "styled-components";
import { StateContext } from "../../contextApi"

import NoticeIcon from "../../assets/img/noticeIcon.inline.svg";
import PerfectScrollbar from "react-perfect-scrollbar";
import BackArrow from "../../assets/img/back-arrow.inline.svg";

export default function AgreementPolicyModal() {

    const [{ }, dispatch] = useContext(StateContext)

    useEffect(() => {
        document.body.classList.add("backdrop-init");
        return () => {
            //document.body.classList.remove("backdrop-init");
        };
    }, []);

    const closeModal = async () => {
        dispatch({
            key: "agreementPolicyForm",
            value: false,
            type: "CHANGE_VIEW_MODALS",
        })
    }

    return (
        <React.Fragment>
            <LoanCalculatorTermsView>
                <div className="modal modal-terms modal-backdrop fadeIn animated">
                    <div className="modal-content kudaFadeInUp animated">
                        <div className="kuda-modal--content flex flex-column justify-between">
                            <div className="justify-center kuda-payment--wrap">

                                <button
                                    onClick={closeModal}
                                    type="button"
                                    className="back-to color-primary"
                                >
                                    <span className="backArrow">
                                        <BackArrow />
                                    </span>
                                    Back
                                </button>

                                <div className="justify-center flex mt-3 mb-2">
                                    <h2 className="heading">Before you complete this loan eligibility calculator</h2>
                                </div>
                                <div className="justify-center flex  icon mb-3">
                                    <NoticeIcon />
                                </div>

                                <div className="payment-wrap">
                                    <PerfectScrollbar className="kuda-terms--wrap animated kudaFadeInUp">
                                        <div className="mt-3">
                                            <h6 className="sub-text">
                                                To confirm this, we require some preliminary personal information from you.
                                                These are (i) Full Name, (ii) Date of Birth; (iii) Bank Verification Number (BVN)
                                                and (iv) email address. This will enable us to quickly determine if you would be eligible for a Kuda MFB Loan,
                                                should you become a Kuda MFB customer by opening an account with us.
                                                We will also share marketing and related information on how to open your Kuda MFB Account.
                                            </h6>
                                        </div>
                                        <div className="mt-3">
                                            <h6 className="sub-text">
                                                We confirm that we will only collect, store and process the personal data you are sharing
                                                with  us  for  the  purposes  we  have indicated  above  subject  to  applicable laws.
                                                Our <span className="color-secondary text-bold link-decoration cursor-pointer">Privacy Policy</span> contains information about how we collect, store and process your personal data.
                                            </h6>
                                        </div>
                                        <div className="mt-3">
                                            <h6 className="sub-text">
                                                By clicking “I Agree” below, you hereby authorise Kuda MFB to collect, use, save, disclose
                                                and / or process the personal data you are providing to us for the purposes indicated above.
                                                If you do not wish to provide your personal data and the required consent, please do not proceed.
                                            </h6>
                                        </div>

                                    </PerfectScrollbar>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </LoanCalculatorTermsView>
        </React.Fragment>
    );
}

const LoanCalculatorTermsView = styled.div`
    max-width: 518px;

    .modal-terms .kuda-modal--content {
        height: 97%;
    }
    .back-to{
        background: none;
      }

    .modal-terms .modal-content {
        max-width: 517px;
    }
    
    .heading {
        font-style: normal;
        font-weight: 800;
        font-size: 25px;
        line-height: 34px;
        text-align: center;
        max-width: 344px;
        color: var(--primaryColor);
    }
    .sub-text {
        font-style: normal;
        font-weight: 400;
        font-size: 13px;
        line-height: 18px;
        color: #000000;
    }
    .modal-content {
        padding: 55px 55px 61px;
    }

    .payment-wrap{
        height: 342px;
        overflow-y: auto;

        .scrollbar-container {
            min-height: 300px;
        }
    } 

    @media only screen and (max-width: 576px) {
        .modal-terms .modal-content {
            max-height: none;
            padding: 42px 20px 23px;
        }
        .sub-text {
            font-size: 0.95rem;
        }
       
        .payment-wrap .scrollbar-container {
            min-height: 300px;
        }
    }

    @media only screen and (max-height: 750px) {
        .payment-wrap .scrollbar-container {
            min-height: 300px;
        }
        .modal-terms .modal-content {
            height: auto !important;
            max-height: none;
        }
    }
`;
